module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/amex@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/amex@3x.png
// module id = 1153
// module chunks = 0